import * as React from "react";
import { randomHex } from "~/util/hexString";
import { DefaultButton, SelectionMode, CheckboxVisibility, Icon, IColumn, DetailsList } from "office-ui-fabric-react";
import { RouteComponentProps } from "react-router";
import { getCollections, getLanguages } from "~/state/action";
import { RootState } from "~/state";
import { connect } from "react-redux";
import { Collection } from "typings";
import { IconStyle } from "../product/productList/ListSetting";
import { DetailListStyle } from "../product/products.style";
import { getStatusText } from "~/util/productStatus";


interface Props
{
   
}



const CollectionOverview: React.FunctionComponent<Props & RouteComponentProps<{ collectionId: string }> & StateProps> = props =>
{
    const onCreateNewClick = () =>
    {
        navigateToCollection(randomHex(24));
    };

    const navigateToCollection = (id: string) =>
    {
        props.history.push("/collections/" + id);
    };

    const columns: IColumn[] = [
        { key: "Title", name: "Title", fieldName: "name", minWidth: 200,  maxWidth: 400, isResizable: true },
        { key: "Id", name: "Id", fieldName: "id", minWidth: 200, isResizable: true },
        { key: "Status", name: "Status", fieldName: "status", minWidth: 100, isResizable: true, 
            onRender: (collection: Collection) =>
            {
                const icon =  <Icon iconName="StatusCircleInner" className="ms-Edit" title="Edit" />;
                const status = getStatusText(collection.status === undefined ? 0 : collection.status);
              
                return <div className={`status-${status}`}>{icon}</div>;
            }
        },
        { key: "edit", name: " ", fieldName: "edit", minWidth: 46, maxWidth: 100, isResizable: true,  
            onRender: (collection: Collection) =>
            {
                const iconEdit =  <Icon iconName="SingleColumnEdit" className="ms-Edit" title="Edit" />;
                // tslint:disable-next-line:react-this-binding-issue
                return <IconStyle onClick={() => navigateToCollection(collection.id)} >{iconEdit} Edit</IconStyle>;
            }
        }

    ];
    return (
        <div>
            <DefaultButton onClick={onCreateNewClick} text="Create Collection" />
            <br/> <br/>
            <DetailListStyle>
                <DetailsList
                    items={props.collections}
                    columns={columns}
                    isHeaderVisible={true}
                    selectionMode={SelectionMode.none}
                    // selection={this.selection}
                    checkboxVisibility={CheckboxVisibility.always}
                    checkboxCellClassName="checkbox-square"   
                                    
                />
            </DetailListStyle>
        </div>
    );

};

const mapStateToProps = (state: RootState, ownProps: Props) =>
{
    return {
        languages: getLanguages(state),
        collections: getCollections(state)
    };
};

const mapDispatchToProps = (dispatch: any, ownProps: Props) => ({
   
});
type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(CollectionOverview);



// WEBPACK FOOTER //
// ./src/components/collection/index.tsx